import es, { humanized as humanizedEs, remaining as remainingEs } from "./es";
import pt, { humanized as humanizedPt, remaining as remainingPt } from "./pt";
export var humanized = {
  es: humanizedEs,
  pt: humanizedPt
};
export var remaining = {
  es: remainingEs,
  pt: remainingPt
};
export default {
  es: es,
  pt: pt
};